export default __webpack_public_path__ + "static/media/icArrow.57ce9cb0.svg";